import { Query, QueryResult } from "material-table";
import qs from "qs";

import { ApiService } from "services/Api.service";

import { Prize, PrizeDTO } from "models/prize/Prize";
import { PrizeOrder, PrizeOrderDTO } from "models/prize/order/PrizeOrder";

import { EditPrizeFormValues } from "components/prize/prize/edit/Edit";

import {
  Query as TableQuery,
  QueryResult as TableQueryResult
} from "../../components/common/table/types";
import { constructQueryParams } from "utils/query/constructQueryParams";
import { tableConstructQueryParams } from "utils/query/tableConstructQueryParams";

export interface PrizeServiceInterface {
  list(query: Query<Prize>, params?: any): Promise<QueryResult<Prize>>;
  get(Prize: Prize): Promise<Prize>;
  edit(prize: Prize, values: EditPrizeFormValues): Promise<Prize>;
  orderList({
    query
  }: {
    query: TableQuery;
  }): Promise<TableQueryResult<PrizeOrder>>;
}

export class PrizeService implements PrizeServiceInterface {
  private _apiService: ApiService;

  constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  async list(query: Query<Prize>, params?: any): Promise<QueryResult<Prize>> {
    const queryParams = {
      ...constructQueryParams<Prize>(query),
      ...params
    };

    const { count, list } = await this._apiService.get(
      "/steve/admin/item",
      {
        searchFields: [],
        ...queryParams
      },
      {
        paramsSerializer: (params: any) => qs.stringify(params)
      }
    );

    return {
      totalCount: count,
      page: query.page,
      data: list.map((prize: PrizeDTO) => Prize.create(prize))
    };
  }

  async get(prize: Prize): Promise<Prize> {
    return await Promise.resolve(prize);
  }

  async edit(prize: Prize, data: EditPrizeFormValues): Promise<Prize> {
    return await this._apiService.put(`/steve/admin/item/${prize.id}`, data);
  }

  public async orderList({
    query
  }: {
    query: TableQuery;
  }): Promise<TableQueryResult<PrizeOrder>> {
    const queryParams = {
      ...tableConstructQueryParams(query)
    };

    const { count, list } = await this._apiService.get(
      `/steve/admin/record/order`,
      {
        searchFields: [],
        ...queryParams
      },
      {
        paramsSerializer: (params: any) => qs.stringify(params)
      }
    );

    return {
      count,
      list: list.map((prizeOrder: PrizeOrderDTO) =>
        PrizeOrder.create(prizeOrder)
      )
    };
  }
}
